import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export interface universalSearchResultInterface {
    id: number
    merchantId: number
    name?: string
    title?: string
    merchantSku?: string
    referenceId?: string
    isCaseForwarding?: string
    fbaShipmentId?: string
    inboundPlanId?: string
    channelIdentifier?: string
}

export const universalSearch = async (query: string): Promise<universalSearchResultInterface[]> => {
    const response = await baseAxios.get<{ items: universalSearchResultInterface[] }>(`/api/search?q=${query}`);

    return response.data.items;
};

export default (axios: AxiosInstance = baseAxios): { universalSearch: (query: string) => Promise<universalSearchResultInterface[]>; } => ({
    universalSearch: async (query: string): Promise<universalSearchResultInterface[]> => {
        const response = await axios.get<{ items: universalSearchResultInterface[] }>(`/api/search?q=${query}`);

        return response.data.items;
    },
});
